/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EReplayScrollEvent {
  SingleDay = 'Scroll_SingleDayCard_List',
  MultiDay = 'Scroll_MultidayCard_List'
}
